module.exports = __webpack_public_path__ + "static/media/courses.0fb53819.png";